module.exports = __webpack_public_path__ + "media/26_Long.0b40a649.mp3";